// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v0Bm","label":"styles_label__3vW0e"};